module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<app-header id=\"app-header-elem\"></app-header>\n<ngx-spinner size=\"default\" color=\"#f4696b\" type=\"ball-newton-cradle\"> </ngx-spinner>\n<div class=\"app-scrollable-content\" [style.top.px]=\"headerHeight\">\n        <router-outlet></router-outlet>\n        <app-footer></app-footer>\n</div>\n\n<!--<span appCustomAttribute customHower=\"blue\"> customElement </span>-->\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./public/app/app.component.html
// module id = ./public/app/app.component.html
// module chunks = main